import { Get, Put } from "./api";

export const getAOs = async () => {
  const result = await Get('/api/aos');

  return result.data;
};

export const getAOStats = async () => {
  const result = await Get('/api/aos/stats');

  return result.data;
};

export const getAOByID = async (aoId) => {
  const result = await Get(`/api/ao/${aoId}`);

  return result.data;
};

export const updateAO = async (aoId, data) => {
  const result = await Put(`/api/ao/${aoId}`, data);

  return result.data;
};
